import { Stack, StackProps, Typography } from '@mui/material';
import Image from 'next/image';

import { cards } from '@/assets/materials/cards';

export interface CoreItem {
  id: number;
  icon: any;
  title?: string;
  description?: string;
}

interface CoreLaunchPadCardProps extends StackProps {
  item: CoreItem;
}

export const CoreLaunchPadCard = ({ item, ...rest }: CoreLaunchPadCardProps) => {
  return (
    <Stack gap={{ xs: 2, sm: 5 }} width={'100%'} height={'100%'} {...rest}>
      <Stack
        position={'relative'}
        width={{ xs: '40px', sm: '62px' }}
        height={{ xs: '40px', sm: '62px' }}
        alignItems={'center'}
        justifyContent={'center'}>
        <Image
          width={32}
          height={32}
          src={item.icon}
          alt={item?.title ?? ''}
          objectFit={'contain'}
          className={'w-5 h-5 sm:w-8 sm:h-8 z-10'}
        />
        <Stack position={'absolute'} top={0} left={0} right={0} bottom={0} zIndex={1}>
          <Image src={cards.card_icon} alt={item?.title ?? ''} layout={'fill'} objectFit={'contain'} />
        </Stack>
      </Stack>
      <Stack gap={2}>
        {item.title ? (
          <Typography
            component={'h5'}
            variant={'headLarge1'}
            fontSize={{ xs: '18px', sm: '24px' }}
            textAlign={'center'}
            color={'#FFFFFF'}>
            {item.title}
          </Typography>
        ) : null}
        {item.description ? (
          <Typography
            variant={'bodyLarge'}
            color={'#FFFFFF'}
            className={'mix-blend'}
            textAlign={'center'}
            fontSize={{ xs: '14px', sm: '18px' }}>
            {item.description}
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
};
